<template>
	<div id="app">
		<header class="header">
			<div class="main_sitelogo">
				<router-link to="/">
					<img
						src="./assets/img/common/site_title_noyear.svg"
						alt="Recruiting Kureha"
					/>
				</router-link>
			</div>
			<div class="nav_set">
        <div class="main_spotlight">
          <router-link to="/newgraduate/">
            <span>
              新卒採⽤
            </span>
            <span>
              企画開発職系（総合職）
            </span>
          </router-link>
          <div>
            <a href="https://job.axol.jp/qd/s/kureha_26/entry/" target="_blank">
              <div>
                ENTRY
              </div>
            </a>
            <a href="https://job.axol.jp/qd/s/kureha_26/mypage/" target="_blank">
              <div>
                MY PAGE
              </div>
            </a>
          </div>
        </div>
        <a href="https://www.kureha-saiyou.com" target="_blank">
          <div class="main_new-graduate-recruit">
            <span>
             <span>新卒採用</span>
            <span>実務推進職系（⼀般職）</span>
            </span>
            <IconBase :width="12" iconColor="#FFFFFF" class="icon_base"
            ><Blank
            /></IconBase>
          </div>
        </a>
        <router-link to="/midcareer">
          <div class="main_recruit">
            キャリア採⽤
          </div>
        </router-link>
				<div class="nav_button" v-on:click="openHandler" v-bind:class="openObj">
					<div class="nav_button-inner">
						<i></i>
						<i></i>
						<i></i>
					</div>
				</div>
			</div>
		</header>
		<MainNav v-bind:class="openObj" />

		<router-view class="router-view" />

    <div>
      <main-footer />
    </div>
    <div class="footer-line">
      <div></div>
    </div>
		<footer class="footer">

			<div class="footer_inner">
				<p class="copyright">
					Copyright © 2020 KUREHA CORPORATION All rights reserved.
				</p>
				<nav class="footer-nav">
					<ul>
						<!-- | -->
						<li>
							<a href="https://www.kureha.co.jp/" target="_self">
								クレハ オフィシャルHP
							</a>
						</li>
						<!-- | -->
						<li>
							<a href="https://www.kureha.co.jp/policies/" target="_self">
								プライバシーポリシー
							</a>
						</li>
						<!-- | -->
						<li>
							<a href="https://www.kureha.co.jp/terms/" target="_self">
								サイト利用にあたって
							</a>
						</li>
						<!-- | -->
					</ul>
				</nav>
			</div>
		</footer>
	</div>
</template>

<script>
// @ is an alias to /src
import MainNav from '@/components/MainNav.vue';
import Blank from "@/components/icons/Blank.vue";
import IconBase from "@/components/IconBase.vue";
import MainFooter from "@/components/MainFooter.vue";

export default {
	name: 'home',
	components: {
    MainFooter,
    IconBase, Blank,
		MainNav,
	},
	data() {
		return {
			openObj: {
				open: false,
			},
		};
	},
	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.openObj.open = false;
			}
			this.createPageTitle(to);
		},
    'openObj.open': function (value){
      document.querySelector('body').style.overflowY = value ? 'hidden' : 'auto'
    }
	},
	methods: {
		openHandler: function () {
			this.openObj.open = !this.openObj.open;
		},
		closeHandler: function () {
			this.openObj.open = false;
		},
		createPageTitle: function (to) {
			// タイトルを設定
			if (to.meta.title) {
				var setTitle = to.meta.title;
				document.title = setTitle;
				document
					.querySelector("meta[property='og:title']")
					.setAttribute('content', setTitle);
			} else {
				document.title = '株式会社クレハ 採用サイト';
				document
					.querySelector("meta[property='og:title']")
					.setAttribute('content', '株式会社クレハ 採用サイト');
			}
			// メタタグ設定
			if (to.meta.desc) {
				var setDesc = to.meta.desc;
				document
					.querySelector("meta[name='description']")
					.setAttribute('content', setDesc);
				document
					.querySelector("meta[property='og:description']")
					.setAttribute('content', setDesc);
			} else {
				document
					.querySelector("meta[name='description']")
					.setAttribute(
						'content',
						'「どこにも無ければ、創ればいい」「ナケレバ、ツクレバ。」の開発精神のもとに、独自技術でスペシャリティを追求し、さまざまな製品を生み出してきた株式会社クレハの採用サイトです。'
					);
				document
					.querySelector("meta[property='og:description']")
					.setAttribute(
						'content',
						'「どこにも無ければ、創ればいい」「ナケレバ、ツクレバ。」の開発精神のもとに、独自技術でスペシャリティを追求し、さまざまな製品を生み出してきた株式会社クレハの採用サイトです。'
					);
			}
			// メタURL
			if (to.meta.url) {
				var setUrl = to.meta.url;
				document
					.querySelector("meta[property='og:url']")
					.setAttribute('content', setUrl);
			} else {
				document
					.querySelector("meta[property='og:url']")
					.setAttribute('content', location.href);
			}
		},
	},
	mounted() {
		var to = this.$route;
		this.createPageTitle(to);
	},
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=RocknRoll+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
body {
	color: #000;
	font-family: '游ゴシック体', YuGothic, '游ゴシック', 'Yu Gothic', 'メイリオ',
		sans-serif;
	margin: 0;
	padding: 0;
	line-height: 2;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	--lightGreen: #3fae00;
	--darkGreen: #00797f;
  --darkBlue: #3EA6C6;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 80px;
	max-width: 100%;
	margin: 0 auto;
	position: fixed;
	width: 100%;
	z-index: 100;
	background-color: #fff;
	top: 0;
	@media print, screen and (max-width: 900px) {
		height: 50px;
	}
}

/* normalize */
html {
	-webkit-text-size-adjust: 100%;
	-ms-text-size-adjust: 100%;
}
body {
	margin: 0;
}
article,
footer,
header,
nav,
section {
	display: block;
}
video {
	display: inline-block;
	vertical-align: baseline;
}
b,
strong {
	font-weight: bold;
}
h1 {
	font-size: 2em;
	margin: 0.67em 0;
}
small {
	font-size: 80%;
}
img {
	border: 0;
	max-width: 100%;
	height: auto;
}
button,
input,
select,
textarea {
	color: inherit;
	margin: 0;
}
button {
	overflow: visible;
	border-color: inherit;
	padding: 0;
	&:focus {
		outline: none;
	}
}
button,
select {
	text-transform: none;
}
button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
	-webkit-appearance: button;
	cursor: pointer;
}
button[disabled],
html input[disabled] {
	cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
	border: 0;
	padding: 0;
}
input {
	line-height: normal;
}
input[type='checkbox'],
input[type='radio'] {
	box-sizing: border-box;
	padding: 0;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	height: auto;
}
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration {
	-webkit-appearance: none;
}
textarea {
	overflow: auto;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
td,
th {
	padding: 0;
}
ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
ol {
	margin: 1em;
	padding: 0;
}
p {
	line-height: 2em;
	margin-top: 1.5em;
}
a {
	background-color: transparent;
	color: inherit;
	text-decoration: none;
	transition: 0.2s;
}
i,
em {
	font-style: normal;
}
@media print, screen and (min-width: 768px) {
	a:not([href^='tel']):not(.comingsoon):hover {
		opacity: 0.5;
	}
}
a[href^='tel'] {
	cursor: default;
	text-decoration: none;
}
*:focus {
	outline: 0;
}
.main_sitelogo {
	// width: 100%;
	height: 80%;
	display: flex;
	align-items: center;
  margin-right: 24px;
	a {
		height: 62%;
		width: auto;
		margin-top: 5%;
		margin-left: 9%;
	}
	img {
		height: 100%;
		max-width: 100%;
		vertical-align: top;
	}
}
.main_entry {
	height: 100%;
	background-color: #00797f; //まとめる
	color: #fff;
	// width: 240px;
	width: 170px;
	font-weight: bold;
	font-size: 26px;
	display: flex;
	align-items: center;
	justify-content: center;
	letter-spacing: 0.1em;
	@media print, screen and (max-width: 900px) {
		display: none;
	}
}
.main_mypage {
	@extend .main_entry;
	background-color: #3fae00;
	margin-left: 5px;
}
.main_recruit{
  @extend .main_entry;
  background-color: var(--darkBlue);
  margin-left: 5px;
  font-size: 18px;
}

.main_new-graduate-recruit{
  @extend .main_entry;
  justify-content: space-between;
  background-color: #00A589;
  margin-left: 5px;
  width: 200px;
  & > span{
    padding-left: 16px;
    & > span{
      display: block;
      letter-spacing: 0;
      &:first-child{
        font-size:18px ;
        line-height: 28px;
      }
      &:last-child{
        font-size: 14px;
        line-height: normal;
      }
    }
  }
  & > svg {
    padding-right: 16px;
  }
}

.main_spotlight{
  min-width: 308px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //background: linear-gradient(278.32deg, #3FA800 0.38%, #00797F 98.46%);
  @media print, screen and (max-width: 900px) {
    display: none;
  }
  & > a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-left: 16px;
    padding-right: 35px;
    border-right: 1px solid white;
    background: linear-gradient(278.32deg, #3FA800 0.38%, #00797F 100%);
    & > span {
      display: block;
      max-width: fit-content;
      color: white;
      font-weight: 700;
      letter-spacing: 0;
      &:first-child{
        font-size: 18px;
        line-height: 28px;
      }
      &:last-child{
        font-size: 14px;
        line-height: normal;
      }
    }
  }

  & > div {
    height: 100%;
    & > a {
      box-sizing: border-box;
      display: block;
      height: 50%;
      background: #3FA800;
      &:first-child{
        border-bottom: 1px solid white;
      }

      & > div{
        height: 100%;
        width: 118px;
        font-size: 15px;
        font-weight: 700;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

}
.nav_set {
	display: flex;
	height: 100%;
	a {
		text-transform: uppercase;
	}
}
.nav_button {
	cursor: pointer;
	// background-color: #3fae00;
	background-color: #fff;
	height: 100%;
	width: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	@media print, screen and (max-width: 900px) {
		width: 50px;
	}
	&.open {
		.nav_button-inner {
			i:nth-child(1) {
				transform: rotate(45deg) scale(0.8, 0.05);
			}
			i:nth-child(2) {
				display: none;
			}
			i:nth-child(3) {
				transform: rotate(-45deg) scale(0.8, 0.05);
			}
		}
	}
}
.nav_button-inner {
	width: 60%;
	height: 80%;
	top: 0;
	position: relative;
	i {
		position: absolute;
		// background-color: #fff;
		background-color: #00797f;
		width: 100%;
		height: 100%;
		display: block;
		transform: scale(1, 0.05);
		transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	}
	i:nth-child(1) {
		transform: scale(1, 0.05) translateY(0%);
	}
	i:nth-child(2) {
		transform: scale(1, 0.05) translateY(600%);
	}
	i:nth-child(3) {
		transform: scale(1, 0.05) translateY(-600%);
	}
}
.router-view {
	margin-top: 80px;
	position: relative;
	@media print, screen and (max-width: 900px) {
		margin-top: 50px;
	}
}

.footer-line{
  padding: 0 36px;
  @media print, screen and (max-width: 900px) { padding: 0 20px }
 & > div{
   height: 1px;
   background-color: var(--darkGreen);
 }
}
.footer {
	font-size: 10px;
  color: var(--darkBlue);
	//color: #00797f;
	margin: 0 auto;
	//border-top: 1px solid #00797f;
	padding: 10px 36px;
  box-sizing: border-box;
  @media print, screen and (max-width: 900px) { padding: 10px 20px }
	.footer_inner {
		margin: 0 auto;
		max-width: 98%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		@media print, screen and (max-width: 900px) {
			flex-direction: column-reverse;
			// max-width: 98%;
		}
	}
}
.lab-entrance + .footer,
.lab-staff + .footer,
.gen-work + .footer,
.lab-staff + .footer,
.special + .footer,
.gen-entrance + .footer {
	border-top: 0;
}
.lab-entrance + .footer {
	position: fixed;
	bottom: 0;
	z-index: 1;
	width: 100%;
	background-color: #fff;
	max-width: 100%;
}
.copyright {
	margin: 0;
  color: var(--darkGreen);
}
.footer-nav ul {
	display: flex;
	justify-content: center;
	align-items: center;
	@media print, screen and (max-width: 900px) {
		//display: grid;
		//grid-template-columns: 3em 1fr 1fr 3em;
		//grid-template-rows: 1.5em 2.5em;
	}
	li {
		//padding: 0em 1em;
		text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
		@media print, screen and (min-width: 901px) {
			padding-left: 0;
		}
		&:before {
      content: '|';
      color: var(--darkGreen);
		}

    &:last-child{
      &:after {
        content: "|";
        color: var(--darkGreen);
      }
    }
	}
	li:first-child {
		// margin-bottom: 1em;
		grid-column: 2/4;
		grid-row: 1/2;
	}
	li:nth-child(2) {
		grid-column: 1/3;
		grid-row: 2/3;
	}
	li:nth-child(3) {
		grid-column: 3/5;
		grid-row: 2/3;
		&:after {
			@media print, screen and (min-width: 901px) {
				content: '|';
			}
		}
	}
	a {
    color: var(--darkGreen);
		@media print, screen and (min-width: 901px) {
			padding: 0 1em;
			font-size: 12px;
		}
		@media print, screen and (max-width: 900px) {
			//text-decoration: underline;
			padding: 1em;
      line-height: normal;
		}
	}
}
</style>
